import customImageWidthURLBuilder from '@cc-shopping/utils/custom-image-width-url-builder';
import { Box } from '@mui/material';
import { forwardRef } from 'react';
import { useReviewContext } from '../../../Context';
import ApplyNowContainer from '../components/ApplyNowContainer';
import CardImage from '../components/CardImage';
import Rating from '../components/Rating';
import Title from '../components/Title';

export const DesktopSidebarProduct = forwardRef<HTMLDivElement, unknown>((_, ref) => {
  const {
    marketplaceEntity: {
      image: { resizable: resizableImage, medium: mediumImage },
    },
  } = useReviewContext();

  const { optimized } = customImageWidthURLBuilder(
    resizableImage,
    {
      customImageWidth: mediumImage.width,
      customImageQuality: 100,
      imageParentWidth: 294,
    },
    mediumImage.url,
  );

  return (
    <Box
      ref={ref}
      sx={{
        display: 'flex',
        flexDirection: 'column',
        mt: 3,
        ml: 6,
        mr: 3,
        width: optimized.parentElement.width,
      }}
    >
      <CardImage source={optimized.image.url} height={optimized.parentElement.height} />
      <Box
        sx={{
          my: 2,
          textAlign: 'center',
        }}
      >
        <Title />
      </Box>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          mb: 1,
        }}
      >
        <Rating />
      </Box>
      <ApplyNowContainer />
    </Box>
  );
});
